import { ControlSize } from "shared/enums/ControlSizeEnum";
import Button from "components/common/controls/Button";

interface Props {
  text: string;
  onClick: () => void;
}
export default function SubscriptionPlanButton(props: Props) {
  return (
    <>
      <Button
        text={props.text}
        size={ControlSize.Large}
        radiusSize={ControlSize.Midium}
        className="w-50"
        onClick={props.onClick}
      />
    </>
  );
}
